const clampPercentage = (percentage: number) => Math.max(Math.min(percentage, 100), 0);

export const calculatePercentFromRange = (value: number, min: number, max: number) =>
    value ? clampPercentage((value - min) / (max - min) * 100) : 0;